export enum GameCardContainerType {
  Box = 'box',
  Tall = 'tall',
  Wide = 'wide',
}

export enum SectionType {
  TALL = 'TALL',
  TALL_REVERSE = 'TALL-REVERSE',
  DOUBLE_TALL = 'DOUBLE-TALL',
  GRID = 'GRID',
  WIDE = 'WIDE',
  WIDE_REVERSE = 'WIDE-REVERSE',
  DOUBLE_WIDE = 'DOUBLE-WIDE',
  HERO = 'HERO',
  // Composite section types for half-width layouts
  TALL_PLUS_GRID = 'TALL+GRID',
  HERO_PLUS_TALL = 'HERO+TALL',
  GRID_PLUS_TALL = 'GRID+TALL',
  TALL_PLUS_HERO = 'TALL+HERO',
}

export enum GridWidth {
  FULL = 'FULL',
  HALF = 'HALF',
}

export interface SectionConfig {
  type: SectionType;
  games?: string[];
  custom_tile_id?: string;
}

export interface TileRowCollection {
  id: string;
  SeeMoreViewAll: boolean;
  Width: GridWidth;
  half_width_tile?: SectionConfig;
  first_full_width_tile?: SectionConfig;
  second_full_width_tile?: SectionConfig;
  third_full_width_tile_block?: SectionConfig;
  internal_name: string;
}
